// src/components/ndr-management/NDRSearchForm.jsx
import React from "react";

// NDR Status Options (without codes displayed)
const NDR_STATUS_OPTIONS = [
  { code: "0", label: "Unknown Exception" },
  { code: "1", label: "Customer Unavailable" },
  { code: "2", label: "Rejected by Customer" },
  { code: "3", label: "Delivery Rescheduled" },
  { code: "4", label: "No Attempt" },
  { code: "5", label: "Customer Unreachable" },
  { code: "6", label: "Address Issue" },
  { code: "7", label: "Payment Issue" },
  { code: "8", label: "Out Of Delivery Area" },
  { code: "9", label: "Order Already Cancelled" },
  { code: "10", label: "Self Collect" },
  { code: "11", label: "Shipment Seized By Customer" },
  { code: "12", label: "Customer wants open delivery" },
  { code: "13", label: "Shipment Misrouted by logistics partner" },
  { code: "14", label: "OTP-based cancellation" },
  { code: "15", label: "OTP mismatch or unavailable" },
];

export default function NDRSearchForm({ filters, setFilters, onSearch, onReset }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <h2 className="text-xl font-semibold mb-4">Search Filters</h2>

      {/* All filters visible by default */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Order Reference Number
          </label>
          <input
            type="text"
            name="orderReferenceNumber"
            value={filters.orderReferenceNumber}
            onChange={handleChange}
            placeholder="Enter order reference"
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            AWB Number
          </label>
          <input
            type="text"
            name="awbNumber"
            value={filters.awbNumber}
            onChange={handleChange}
            placeholder="Enter AWB number"
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            NDR Reason
          </label>
          <select
            name="ndrStatusCode"
            value={filters.ndrStatusCode}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          >
            <option value="">All NDR Reasons</option>
            {NDR_STATUS_OPTIONS.map((option) => (
              <option key={option.code} value={option.code}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Order Creation Date Time From (IST)
          </label>
          <input
            type="datetime-local"
            name="fromDateTime"
            value={filters.fromDateTime}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Order Creation Date Time To (IST)
          </label>
          <input
            type="datetime-local"
            name="toDateTime"
            value={filters.toDateTime}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>
      </div>

      {/* Action buttons */}
      <div className="flex gap-3">
        <button
          onClick={onSearch}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors"
        >
          Search
        </button>
        <button
          onClick={onReset}
          className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-medium transition-colors"
        >
          Reset
        </button>
      </div>
    </div>
  );
}